import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultSingleItemPickerAssets, singleItemPickerAssetsValidator } from './assets';
import { defaultSingleItemPickerCdnOptions, singleItemPickerCdnOptionsValidator } from './cdn-options';
import { defaultSingleItemPickerConfig, singleItemPickerConfigValidator } from './config';
import { defaultSingleItemPickerDisplayText, singleItemPickerDisplayTextValidator } from './display-text';
import { singleItemPickerEventsValidator } from './events';
export const singleItemPickerPropsValidator = Validator.object({
    itemHopk: nonEmptyStringValidator,
    siteId: nonEmptyStringValidator,
    displayText: singleItemPickerDisplayTextValidator,
    config: singleItemPickerConfigValidator,
    assets: singleItemPickerAssetsValidator,
    events: singleItemPickerEventsValidator,
    cdnOptions: singleItemPickerCdnOptionsValidator
});
/**
 * Default props for the Single Item Picker component.
 */
export const defaultSingleItemPickerProps = {
    itemHopk: undefined,
    siteId: undefined,
    displayText: defaultSingleItemPickerDisplayText,
    config: defaultSingleItemPickerConfig,
    assets: defaultSingleItemPickerAssets,
    events: {},
    cdnOptions: defaultSingleItemPickerCdnOptions
};
